import HLJS_THEME_CSS from "highlight.js/styles/github-dark.css?inline"

import { MESSAGE_BODY_CSS } from "@productlane/ui"

// Shadow DOM keeps the app's prose and .html-content rules off the message, so a
// sender's tables and spacing render the way their mail client wrote them. The
// MESSAGE_BODY_CSS block below only applies to bodies we wrote ourselves, which
// carry MESSAGE_BODY_CLASS, so those match the composer instead.
export const EMAIL_SHADOW_STYLES = `
:host {
	display: block;
	font-size: 0.875rem;
	line-height: 1.45;
	overflow-wrap: anywhere;
	--email-border: rgba(0, 0, 0, 0.12);
	--email-link: var(--text-green-600, #3a986c);
	--email-quote: rgba(0, 0, 0, 0.18);
}
:host([data-theme="dark"]) {
	--email-border: rgba(255, 255, 255, 0.16);
	--email-link: var(--text-green-500, #4cb782);
	--email-quote: rgba(255, 255, 255, 0.22);
}
.email-body {
	overflow-x: auto;
}
p {
	margin: 0 0 1em;
}
p:last-child {
	margin-bottom: 0;
}
a {
	color: var(--email-link);
	text-decoration: none;
}
a:hover {
	text-decoration: underline;
}
img {
	max-width: 100%;
}
/* Fixed pixel widths wrap to the pane instead of clipping (pasted Gmail UI sets 1100px). */
.email-body :is(div, p, table, blockquote, center, ul, ol, h1, h2, h3, h4, h5, h6) {
	max-width: 100%;
}

p > img:only-child:not([width]),
div > img:only-child:not([width]),
a > img:only-child:not([width]) {
	width: 100%;
	height: auto;
}
	
img:not([height]) {
	height: auto;
}
blockquote {
	margin: 0.5em 0;
	padding-left: 0.75em;
	border-left: 2px solid var(--email-quote);
}
ul,
ol {
	margin: 0.5em 0;
	padding-left: 1.5em;
}
li {
	margin: 0.25em 0;
}
hr {
	border: 0;
	border-top: 1px solid var(--email-border);
	margin: 0.75em 0;
}
h1 { font-size: 1.5rem; }
h2 { font-size: 1.25rem; }
h3 { font-size: 1.125rem; }
h4, h5, h6 { font-size: 1rem; }
h1, h2, h3, h4, h5, h6 {
	margin: 0.75em 0 0.35em;
	font-weight: 600;
	line-height: 1.3;
}
pre,
code {
	font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
	font-size: 0.8125rem;
}
pre {
	white-space: pre-wrap;
	overflow-x: auto;
}
${MESSAGE_BODY_CSS}
/* Code from our composer matches the docs code block (.prose pre in shared.css). */
.email-body pre:has(> code) {
	margin: 1.7142857em 0;
	padding: 0.8571429em 1.1428571em;
	border-radius: 0.375rem;
	background-color: #1f2937;
	box-shadow: 0 0 0 0.5px rgba(255, 255, 255, 0.1);
	color: #e5e7eb;
	font-size: 0.875em;
	font-weight: 400;
	line-height: 1.7142857;
}
:host([data-theme="dark"]) .email-body pre:has(> code) {
	background-color: #090a0b;
}
.email-body pre > code {
	font-size: inherit;
}
.email-body code:not(pre > code) {
	padding: 0.125rem 0.25rem;
	border-radius: 0.2rem;
	background-color: rgba(9, 10, 11, 0.05);
	color: #0f0f12;
	font-size: 0.875em;
}
:host([data-theme="dark"]) .email-body code:not(pre > code) {
	background-color: rgba(255, 255, 255, 0.07);
	color: #e5e5e5;
}
${HLJS_THEME_CSS}
`
